import { Dropdown } from "react-bootstrap";
import { UserSession } from "../types";

const AutoPlayControl: React.FC<{
  userSession: UserSession;
  updateUserSession: (session: UserSession) => void;
}> = ({ userSession, updateUserSession }) => {
  const currentOption = userSession.shuffle
    ? "Shuffle"
    : userSession.autoplay
    ? "Autoplay On"
    : "Autoplay Off";
  return (
    <Dropdown>
      <Dropdown.Toggle>{currentOption}</Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            updateUserSession({
              ...userSession,
              autoplay: false,
              shuffle: false,
            });
          }}
        >
          Autoplay Off
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            updateUserSession({
              ...userSession,
              autoplay: true,
              shuffle: false,
            });
          }}
        >
          Autoplay On
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            updateUserSession({
              ...userSession,
              autoplay: true,
              shuffle: true,
            });
          }}
        >
          Shuffle
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AutoPlayControl;
